import database from './database';

const Artists = {
  all: dispatch => {
    database.ref('artists').once('value', (snap) => {
      var artists = snap.val();
      artists = Object.keys(artists).map(artist => {
        artists[artist].id = artist;
        return artists[artist];
      });

      artists = artists.filter(artist => artist.hasOwnProperty("name") && artist.hasOwnProperty("images"));

      artists.sort((a, b) => {
       var nameA=a.name.toLowerCase(), nameB=b.name.toLowerCase();
       if (nameA < nameB) //sort string ascending
        return -1;
       if (nameA > nameB)
        return 1;
       return 0; //default return value (no sorting)
      });
      dispatch({type: 'ARTIST_ADDED', artists});
    });
  },
  get: (dispatch, artistID) => {
    database.ref('artists/' + artistID).once('value').then( snap => {
      var artist = snap.val();
      dispatch({type:'ARTIST_PAGE_LOADED', artist});
    })
  },
  add: artist => {
    let newArtist = database.ref('artists').push();
    return newArtist.set(artist);
  },
  new: () => {
    let newArtistID = database.ref('artists').push().key;
    return newArtistID;
  },
  update: (artistID, artist) => {
    return database.ref('artists/' + artistID).update(artist);
  },
  delete: artistID => {
    return database.ref('artists/' + artistID).remove();
  }
};

const Mediums = {
  all: dispatch => {
    database.ref('mediums').on('value', (snap) => {
      let mediums = snap.val();
      dispatch({type: 'MEDIUMS_LOADED', mediums});
    });
  },
  add: (key, val) => {
    return database.ref('mediums').child(key).set(val);
  }
}

const Admin = {
  all: dispatch => {
    database.ref('artists').on('value', (snap) => {
      var artists = snap.val();
      artists = Object.keys(artists).map(artist => {
        artists[artist].id = artist;
        return artists[artist];
      });

      artists = artists.filter(artist => artist.hasOwnProperty("name"));

      artists.sort((a, b) => {
       var nameA=a.name.toLowerCase(), nameB=b.name.toLowerCase();
       if (nameA < nameB) //sort string ascending
        return -1;
       if (nameA > nameB)
        return 1;
       return 0; //default return value (no sorting)
      });
      dispatch({type: 'ARTIST_ADDED', artists});
    });
  }
}

export default {
  Artists,
  Mediums,
  Admin
}



// WEBPACK FOOTER //
// ./src/agent.js